import { ReactNode } from 'react';
import { PermissionRuleName } from 'constant';

export enum CardSizes {
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
  Grouped = 'grouped',
}
export enum CardNames {
  AllPhases = 'AllPhases',
  StatusUpdates = 'StatusUpdates',
  KeyEventsAndIntervals = 'KeyEventsAndIntervals',
  TasksAtRisk = 'TasksAtRisk',
  BlockedTasks = 'BlockedTasks',
  OverdueTasks = 'OverdueTasks',
  PlannedVsActual = 'PlannedVsActual',
  TasksCompletedLate = 'TasksCompletedLate',
  CountOfTasksAtRisk = 'CountOfTasksAtRisk',
  CountOfTasksOverdue = 'CountOfTasksOverdue',
  CountOfTasksBlocked = 'CountOfTasksBlocked',
  CountOfTasksCompleted = 'CountOfTasksCompleted',
  BusinessGoals = 'BusinessGoals',
}
interface OverviewCard {
  id: number;
  title?: ReactNode;
  cardName?: CardNames;
  hidden?: boolean;
  ruleName?: PermissionRuleName;
}
interface CustomisableCard extends OverviewCard {
  type: CardSizes.Small | CardSizes.Medium | CardSizes.Large;
  content?: string;
}
interface GroupedCustomisableCard extends OverviewCard {
  type: CardSizes.Grouped;
  content: CustomisableCard[];
}

export type OverviewCardPayload = CustomisableCard | GroupedCustomisableCard;

export const data: OverviewCardPayload[] = [
  {
    id: Math.random(),
    type: CardSizes.Grouped,
    content: [
      {
        id: Math.random(),
        type: CardSizes.Small,
        cardName: CardNames.CountOfTasksOverdue,
      },
      {
        id: Math.random(),
        type: CardSizes.Small,
        cardName: CardNames.CountOfTasksAtRisk,
      },
      {
        id: Math.random(),
        type: CardSizes.Small,
        content: 'GC 4',
        cardName: CardNames.CountOfTasksCompleted,
      },
      {
        id: Math.random(),
        type: CardSizes.Small,
        cardName: CardNames.CountOfTasksBlocked,
      },
    ],
  },
  {
    id: Math.random(),
    type: CardSizes.Small,
    cardName: CardNames.AllPhases,
  },
  {
    id: Math.random(),
    type: CardSizes.Small,
    cardName: CardNames.PlannedVsActual,
    ruleName: PermissionRuleName.ProjectPlannedVsActualSection,
  },
  {
    id: Math.random(),
    type: CardSizes.Small,
    cardName: CardNames.BusinessGoals,
    ruleName: PermissionRuleName.ProjectGoalsSection,
  },
  {
    id: Math.random(),
    type: CardSizes.Small,
    cardName: CardNames.StatusUpdates,
  },
  {
    id: Math.random(),
    type: CardSizes.Small,
    cardName: CardNames.OverdueTasks,
  },
  {
    id: Math.random(),
    type: CardSizes.Medium,
    cardName: CardNames.KeyEventsAndIntervals,
  },
  {
    id: Math.random(),
    type: CardSizes.Small,
    cardName: CardNames.TasksAtRisk,
  },
  {
    id: Math.random(),
    type: CardSizes.Small,
    cardName: CardNames.BlockedTasks,
  },
  {
    id: Math.random(),
    type: CardSizes.Small,
    cardName: CardNames.TasksCompletedLate,
  },
];
